export default __webpack_public_path__ + "static/media/logo.420a8a84.png";